// extracted by mini-css-extract-plugin
export default {"Button":"settings-error-fallback-module__Button__Bw2YCog"};